// extracted by mini-css-extract-plugin
module.exports = {"body":"welcome_body__7TUQ9"};